import type { AnyRouter } from "@tanstack/react-router"
import { useNavigate, useSearch } from "@tanstack/react-router"
import {
  WAREHOUSE_SHELVING_LAYOUT_ROUTE_PATH,
  WAREHOUSE_SHELVING_ROUTE_PATH,
} from "routes/app/admin/warehouses/$warehouseId/_layout.shelving"

interface UseWarehouseShelvingSearchReturn {
  searchValue: string
  updateNavigationSearch: (queryValue: string) => void
}

export const useWarehouseShelvingSearch = (): UseWarehouseShelvingSearchReturn => {
  const navigate = useNavigate({ from: WAREHOUSE_SHELVING_ROUTE_PATH })
  const search = useSearch<AnyRouter, undefined, true>({
    from: WAREHOUSE_SHELVING_LAYOUT_ROUTE_PATH,
    strict: true,
  })

  const updateNavigationSearch = (queryValue: string) => {
    navigate({
      search: (prev: Record<string, any>): Record<string, any> => ({
        ...prev,
        query: queryValue,
      }),

      from: WAREHOUSE_SHELVING_ROUTE_PATH,
      replace: true,
    })
  }

  return {
    searchValue: search.query ?? "",
    updateNavigationSearch,
  }
}
